import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { StatutoryPF } from "./PF";
import { StatutoryESI } from "./ESI";
import { StatutoryPT } from "./PT";
import { StatutoryLWF } from "./LWF";

// Payroll > Statutory is a sidebar flyout (see routes.js). Each item has
// its own URL under /admin/payroll/statutory/<item>, matching this
// folder's sub-folders. One hidden route serves them all, since routes
// are matched by prefix, and this component picks the screen from the path.
export const PAYROLL_STATUTORY_BASE_PATH = "/admin/payroll/statutory";

const STATUTORY_SCREENS = {
  pf: StatutoryPF,
  esi: StatutoryESI,
  pt: StatutoryPT,
  lwf: StatutoryLWF,
};

export const PayrollStatutoryHub = () => {
  const { pathname } = useLocation();
  const segment = pathname
    .replace(/\/+$/, "")
    .slice(PAYROLL_STATUTORY_BASE_PATH.length + 1)
    .split("/")[0]
    .toLowerCase();
  const Screen = STATUTORY_SCREENS[segment];

  if (!Screen) {
    return <Redirect to={`${PAYROLL_STATUTORY_BASE_PATH}/pf`} />;
  }
  return <Screen />;
};
